import { useEffect, useRef, useState, useMemo } from "react";
import { useAudio } from "../Contexts/AudiosContext";
import AudioService from "../Services/AudioPlayer";
import arrowleft from "../assets/img/arrowleft.png"
import AudioLyrics from "../Components/AudioLyrics";
import AudioSeo from "../Components/AudioSeo";
import i18n, { _get_i18Lang } from "../i18n";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import WithoutLyrics from "../Images/audiolyrics.svg";
import WithLyrics from "../Images/audiowithoutlyrics.svg";
/* Three-part ornamental frame: TL corner, BL corner, left side bar (flipped for right) */
import lyricsCornerTopLeft from "../Images/Image/lyricsFrameParts/lyricsCornerTopLeft.png";
import lyricsCornerBottomLeft from "../Images/Image/lyricsFrameParts/lyricsCornerBottomLeft.png";
import lyricsSideLeft from "../Images/Image/lyricsFrameParts/lyricsSideLeft.png";
import imgback from "../assets/audioPlayer/img/whiteprevious.svg";
import imgforward from "../assets/audioPlayer/img/whitenext.svg";
import imgpause from "../assets/audioPlayer/img/Pause.svg";
import imgplay from "../assets/audioPlayer/img/bgorangepause.svg";
import imgrepeatOn from "../assets/audioPlayer/img/repeatON.svg";
import imgrepeatOff from "../assets/audioPlayer/img/repeatOFF.svg";
import imgshuffle from "../assets/audioPlayer/img/whiteshuffle.svg";
import volumeIcon from "../Images/volume_up.svg";
import muteIcon from "../Images/volume_off.svg";
import Favadd from "../assets/img/Like -Fill 1.svg";
import Favicon from "../assets/img/Like-Stroke 1.svg";
import { LogInModel } from "./LoginModel";
import "../Styles/AudioPlayerPage.css";

const AudioPlayerPageNew = ({ match }: any) => {
  console.log("AudioPlayerPageNew Render ->", { match });
  const navigate = useNavigate();

  const {
    setAudiosList,
    setIsMinismise,
    audiosList,
    playAudio,
    currentAudio,
    close,
    playingAudio,
    setPlayingAudio,
    refAudio,
    next,
    prev,
    isLiked,
    favaddremove,
  } = useAudio();

  // Keep latest playing id for async list-load callback (avoid restarting same track)
  const currentPlayingIdRef = useRef<string | undefined>(currentAudio?.id);
  currentPlayingIdRef.current = currentAudio?.id;

  const location = useLocation();
  const { t } = useTranslation();
  const state = location.state as {
    audioId: string;
    sorting: string;
    index: number;
    audiocat: string;
    audioAuthor: string,
    title: string,
    audioslug: string,
    pageNum: number,
    otherpreacher: boolean
  };

  const catId = useRef<string | any>(state?.audiocat! || "");
  const auid = useRef<string | undefined>(state?.audioId! || "");

  const [Type, setType] = useState<any | undefined>(
    localStorage.getItem("type")
  );

  // Player control states
  const [shuffle, setShuffle] = useState(false);
  const [repeat, setRepeat] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isFavorite, setIsFavorite] = useState(false);
  const [logIn, setLogIn] = useState(false);
  const [volume, setVolume] = useState(() => {
    const saved = localStorage.getItem("audioVolume");
    return saved ? parseFloat(saved) : 0.8;
  });
  const [isMuted, setIsMuted] = useState(false);
  const [prevVolume, setPrevVolume] = useState(0.5);

  const isLoggedIn = () =>
    !!(localStorage.getItem("Token") && localStorage.getItem("UserId"));

  /** Always resolve the live shared <audio> used for playback */
  const getSharedAudio = (): HTMLAudioElement | null => {
    if (refAudio?.current) return refAudio.current as HTMLAudioElement;
    return document.querySelector("audio");
  };

  // Determine audio type from URL path for SEO
  const audioType = useMemo(() => {
    const pathType = location.pathname.split('/')[1]?.toLowerCase();
    if (pathType === 'pravachans') return 'pravachans';
    if (pathType === 'dailysatsang') return 'DailySatsang';
    return 'audios';
  }, [location.pathname]);

  // Button / related-list labels follow the product being listed
  const seeAllLabelKey = useMemo(() => {
    if (audioType === "pravachans") return "See_All_Pravachan_tr";
    if (audioType === "DailySatsang") return "See_All_DailySatsang_tr";
    return "See_All_Audio_tr";
  }, [audioType]);

  const relatedListLabelKey = useMemo(() => {
    if (audioType === "pravachans") return "Related_pravachans_tr";
    return "Related_audios_tr";
  }, [audioType]);

  // Build canonical path for SEO
  const canonicalPath = useMemo(() => {
    if (currentAudio?.slug) {
      return `/${audioType}/${currentAudio.slug}`;
    }
    return location.pathname;
  }, [audioType, currentAudio?.slug, location.pathname]);

  function getPaginationRange(pageNumber: any, itemsPerPage: any) {
    // Ensure both values are valid positive integers
    if (!Number.isInteger(pageNumber) || pageNumber <= 1) {
      return { start: 0, length: Math.max(0, itemsPerPage) };
    }

    if (!Number.isInteger(itemsPerPage) || itemsPerPage <= 0) {
      return { start: 0, length: 0 };
    }

    const start = (pageNumber - 1) * itemsPerPage;
    const length = itemsPerPage;

    return { start, length };
  }

  const pageNumber = state?.pageNum;
  const itemsPerPage = 12;
  const { start, length } = getPaginationRange(pageNumber, itemsPerPage);

  useEffect(() => {
    // Prevent late API success from re-hiding the floating bar after leave
    let cancelled = false;
    const logdetails: string[] = [];
    logdetails.push(`trigger=useEffect`);
    logdetails.push(`audioId=${auid.current || 'none'}`);
    logdetails.push(`catId=${catId.current || 'none'}`);
    logdetails.push(`Type=${Type || 'none'}`);

    console.log("AudioPlayerPageNew useEffect ->", logdetails.join(" | "), { state });

    // Hide universal floating audio bar while on this full player page
    setIsMinismise(false);
    logdetails.push("action=hide_floating_audio_bar");

    // Leaving full player (header / breadcrumb / any nav) → show floating bar again.
    // Close() clears currentAudio so AudioPlayer still won't render without a track.
    const showFloatingBarOnLeave = () => {
      cancelled = true;
      const leaveLogs: string[] = [];
      leaveLogs.push("action=show_floating_audio_bar_on_unmount");
      console.log("AudioPlayerPageNew cleanup ->", leaveLogs.join(" | "));
      setIsMinismise(true);
    };

    // If the URL is a raw ObjectId (direct visit) and there is NO navigation state,
    // do not fetch/play here — let App.tsx resolve id -> slug and navigate.
    const hasNavStateAudio = !!(location.state && (location.state as any).audioId);
    if (!hasNavStateAudio) {
      logdetails.push("action=skip_load_no_nav_state");
      console.log("AudioPlayerPageNew: raw id in URL and no navigation state — skipping load and waiting for App to resolve slug", logdetails.join(" | "));
      return showFloatingBarOnLeave;
    }

    // Play/open works for guests; favourite/download still require login in AudioPlayer
    logdetails.push("action=load_audio_list");
    console.log("AudioPlayerPageNew: starting to load audio list with AudioPlayer.getAudioPlayer", logdetails.join(" | "));

    // Deep links must win over stale localStorage (e.g. prior DailySatsang visit)
    // otherwise playAudio navigates to the wrong section and App redirects away.
    const pathSegment = (location.pathname.split("/")[1] || "").toLowerCase();
    let resolvedType: "audios" | "pravachans" | "DailySatsang" = "audios";
    if (pathSegment === "pravachans") resolvedType = "pravachans";
    else if (pathSegment === "dailysatsang") resolvedType = "DailySatsang";
    else if (pathSegment === "audios") resolvedType = "audios";

    const prevStoredType = localStorage.getItem("type");
    localStorage.setItem("type", resolvedType);
    setType(resolvedType);
    logdetails.push(`resolved_type=${resolvedType}`);
    logdetails.push(`prev_stored_type=${prevStoredType || "none"}`);
    logdetails.push(`current_type=${resolvedType}`);
    console.log("AudioPlayerPageNew: Current Type ->", logdetails.join(" | "));

    AudioService.getAudiosList(
      _get_i18Lang(),
      start,
      length,
      false,
      state?.audiocat || "",
      state?.audioAuthor || "",
      "",
      state?.sorting! || "",
      "",
      false,
      resolvedType,
    ).then((res) => {
      // Page already left — do not hide floating bar or mutate play state
      if (cancelled) {
        logdetails.push("action=skip_after_unmount");
        console.log("AudioPlayerPageNew -> getAudioPlayer skipped after leave:", logdetails.join(" | "));
        return;
      }

      logdetails.push(`api_status=${res?.status ? 'success' : 'failed'}`);
      console.log("AudioPlayerPageNew -> getAudioPlayer result:", logdetails.join(" | "), res);
      
      if (res?.status) {
        setIsMinismise(false);
        
        logdetails.push(`setting_audios_list count=${res.result.items?.length || 0}`);
        logdetails.push(`requested_id=${state?.audioId || "none"}`);
        logdetails.push(`already_playing_id=${currentPlayingIdRef.current || "none"}`);
        console.log("AudioPlayerPageNew -> Setting audios list ->", logdetails.join(" | "));
        
        setAudiosList(res.result.items);

        // Same track already playing (e.g. opened from list / maximize) — do not restart
        if (state?.audioId && state.audioId === currentPlayingIdRef.current) {
          logdetails.push("action=skip_playAudio_same_track");
          console.log("AudioPlayerPageNew ->", logdetails.join(" | "));
        } else {
          logdetails.push(`action=play_audio index=${state?.index} slug=${state?.audioslug}`);
          console.log("AudioPlayerPageNew -> starting play ->", logdetails.join(" | "));
          playAudio(state?.audioId!, state?.index, state?.audioslug);
        }
        
        const element = document.getElementById(state?.title)
        element?.scrollIntoView();
        
        logdetails.push("action=scroll_to_element");
        console.log("AudioPlayerPageNew -> completed load ->", logdetails.join(" | "));
      }
    }).catch((err) => {
      if (cancelled) {
        logdetails.push("action=skip_after_unmount");
        console.log("AudioPlayerPageNew -> getAudioPlayer error skipped after leave:", logdetails.join(" | "));
        return;
      }
      logdetails.push(`error=${err?.message || 'unknown'}`);
      console.error("AudioPlayerPageNew -> getAudioPlayer error:", logdetails.join(" | "), err);
    })

    return showFloatingBarOnLeave;
  }, [auid, i18n.language, catId, Type]);

  // Show up to 15 related audios; list viewport shows ~5 rows and scrolls
  const RELATED_AUDIO_LIMIT = 15;
  const relatedAudios = useMemo(() => {
    const logdetails: string[] = [];
    logdetails.push(`total_audios=${audiosList.length}`);
    logdetails.push(`current_audio_id=${currentAudio?.id || "none"}`);

    const filtered = audiosList.filter((a) => a.id !== currentAudio?.id);
    const limited = filtered.slice(0, RELATED_AUDIO_LIMIT);

    logdetails.push(`filtered_count=${filtered.length}`);
    logdetails.push(`shown_count=${limited.length}`);
    logdetails.push(`limit=${RELATED_AUDIO_LIMIT}`);
    console.log("AudioPlayerPageNew -> relatedAudios filter ->", logdetails.join(" | "));

    return limited;
  }, [audiosList, currentAudio?.id]);

  // Next track in full playlist (matches AudiosContext.next — audiosList[index + 1])
  const nextPlaylistAudioId = useMemo(() => {
    const logdetails: string[] = [];
    const idx = audiosList.findIndex((x) => x.id === currentAudio?.id);
    logdetails.push(`current_index=${idx}`);
    if (idx < 0 || idx >= audiosList.length - 1) {
      logdetails.push("next_id=none");
      console.log("AudioPlayerPageNew -> nextPlaylistAudioId ->", logdetails.join(" | "));
      return null;
    }
    const nextId = audiosList[idx + 1]?.id ?? null;
    logdetails.push(`next_id=${nextId || "none"}`);
    console.log("AudioPlayerPageNew -> nextPlaylistAudioId ->", logdetails.join(" | "));
    return nextId;
  }, [audiosList, currentAudio?.id]);

  // Player control handlers
  const toggleShuffle = () => {
    const logdetails: string[] = [];
    logdetails.push(`action=toggle_shuffle`);
    logdetails.push(`previous_state=${shuffle}`);
    logdetails.push(`new_state=${!shuffle}`);
    console.log("AudioPlayerPageNew -> toggleShuffle ->", logdetails.join(" | "));
    
    setShuffle(!shuffle);
  };

  const toggleRepeat = () => {
    const logdetails: string[] = [];
    logdetails.push(`action=toggle_repeat`);
    logdetails.push(`previous_state=${repeat}`);
    logdetails.push(`new_state=${!repeat}`);
    console.log("AudioPlayerPageNew -> toggleRepeat ->", logdetails.join(" | "));
    
    setRepeat(!repeat);
  };

  const changePlaybackSpeed = () => {
    const logdetails: string[] = [];
    const speeds = [1, 1.25, 1.5, 1.75, 2];
    const currentIndex = speeds.indexOf(playbackSpeed);
    const nextSpeed = speeds[(currentIndex + 1) % speeds.length];

    logdetails.push(`action=change_speed`);
    logdetails.push(`previous_speed=${playbackSpeed}`);
    logdetails.push(`new_speed=${nextSpeed}`);

    setPlaybackSpeed(nextSpeed);
    const audioElement = getSharedAudio();
    if (audioElement) {
      audioElement.playbackRate = nextSpeed;
      logdetails.push("result=speed_applied");
    } else {
      logdetails.push("result=no_audio_element");
    }
    console.log("AudioPlayerPageNew -> changePlaybackSpeed ->", logdetails.join(" | "));
  };

  const handleSeek = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTime = parseFloat(e.target.value);
    const logdetails: string[] = [];
    logdetails.push(`action=seek`);
    logdetails.push(`from=${currentTime}`);
    logdetails.push(`to=${newTime}`);

    const audioEl = getSharedAudio();
    setCurrentTime(newTime);
    if (audioEl) {
      audioEl.currentTime = newTime;
      logdetails.push("result=seek_applied");
    } else {
      logdetails.push("result=no_audio_element");
    }
    console.log("AudioPlayerPageNew -> handleSeek ->", logdetails.join(" | "));
  };

  const togglePlayPause = () => {
    const logdetails: string[] = [];
    logdetails.push(`action=toggle_play_pause`);
    logdetails.push(`current_state=${playingAudio ? "playing" : "paused"}`);

    const audioEl = getSharedAudio();
    if (!audioEl) {
      logdetails.push("result=no_audio_element");
      console.warn("AudioPlayerPageNew -> togglePlayPause ->", logdetails.join(" | "));
      return;
    }

    // Prefer actual element state over React flag (stays in sync after autoplay)
    const isCurrentlyPlaying = !audioEl.paused && !audioEl.ended;

    if (isCurrentlyPlaying) {
      audioEl.pause();
      setPlayingAudio(false);
      logdetails.push("result=paused");
      console.log("AudioPlayerPageNew -> togglePlayPause ->", logdetails.join(" | "));
      return;
    }

    audioEl
      .play()
      .then(() => {
        setPlayingAudio(true);
        logdetails.push("result=playing");
        console.log("AudioPlayerPageNew -> togglePlayPause ->", logdetails.join(" | "));
      })
      .catch((err: any) => {
        setPlayingAudio(false);
        logdetails.push("result=play_failed");
        logdetails.push(`error=${err?.message || "unknown"}`);
        console.error("AudioPlayerPageNew -> togglePlayPause ->", logdetails.join(" | "), err);
      });
  };

  const playNext = () => {
    const logdetails: string[] = [];
    logdetails.push(`action=play_next`);
    logdetails.push(`current_audio=${currentAudio?.id}`);
    console.log("AudioPlayerPageNew -> playNext ->", logdetails.join(" | "));
    next();
  };

  const playPrevious = () => {
    const logdetails: string[] = [];
    logdetails.push(`action=play_previous`);
    logdetails.push(`current_audio=${currentAudio?.id}`);
    console.log("AudioPlayerPageNew -> playPrevious ->", logdetails.join(" | "));
    prev();
  };

  const handleAddToFavorite = () => {
    const logdetails: string[] = [];
    logdetails.push(`action=toggle_favorite`);
    logdetails.push(`audio_id=${currentAudio?.id}`);
    logdetails.push(`previous_state=${isFavorite}`);
    console.log("AudioPlayerPageNew -> handleAddToFavorite ->", logdetails.join(" | "));

    if (!isLoggedIn()) {
      logdetails.push("result=login_required");
      console.log("AudioPlayerPageNew -> handleAddToFavorite ->", logdetails.join(" | "));
      setLogIn(true);
      return;
    }

    // Prefer shared context favourite so status stays in sync with floating bar
    favaddremove();
    setIsFavorite(!isLiked);
    logdetails.push(`result=toggled`);
    console.log("AudioPlayerPageNew -> handleAddToFavorite ->", logdetails.join(" | "));
  };

  const handleVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(e.target.value);
    const logdetails: string[] = [];
    logdetails.push(`action=volume_change`);
    logdetails.push(`volume=${newVolume}`);

    setVolume(newVolume);
    localStorage.setItem("audioVolume", newVolume.toString());

    const audioEl = getSharedAudio();
    if (audioEl) {
      audioEl.volume = newVolume;
      audioEl.muted = newVolume === 0;
      logdetails.push("result=volume_applied");
    } else {
      logdetails.push("result=no_audio_element");
    }

    if (newVolume > 0) {
      setIsMuted(false);
    } else {
      setIsMuted(true);
    }
    console.log("AudioPlayerPageNew -> handleVolumeChange ->", logdetails.join(" | "));
  };

  const toggleMute = () => {
    const logdetails: string[] = [];
    logdetails.push(`action=toggle_mute`);
    logdetails.push(`was_muted=${isMuted}`);

    const audioEl = getSharedAudio();

    if (isMuted) {
      const restore = prevVolume || 0.5;
      setVolume(restore);
      localStorage.setItem("audioVolume", restore.toString());
      if (audioEl) {
        audioEl.volume = restore;
        audioEl.muted = false;
      }
      setIsMuted(false);
      logdetails.push("result=unmuted");
    } else {
      setPrevVolume(volume || 0.5);
      setVolume(0);
      localStorage.setItem("audioVolume", "0");
      if (audioEl) {
        audioEl.volume = 0;
        audioEl.muted = true;
      }
      setIsMuted(true);
      logdetails.push("result=muted");
    }
    console.log("AudioPlayerPageNew -> toggleMute ->", logdetails.join(" | "));
  };

  const handleShare = () => {
    const logdetails: string[] = [];
    logdetails.push(`action=share`);
    logdetails.push(`audio_id=${currentAudio?.id}`);
    logdetails.push(`audio_slug=${currentAudio?.slug}`);
    console.log("AudioPlayerPageNew -> handleShare ->", logdetails.join(" | "));
    
    // Share functionality
    const shareUrl = `${window.location.origin}/${Type}/${currentAudio?.slug}`;
    if (navigator.share) {
      navigator.share({
        title: currentAudio?.name,
        text: currentAudio?.description || currentAudio?.name,
        url: shareUrl,
      }).catch((err) => {
        logdetails.push(`share_error=${err.message}`);
        console.error("AudioPlayerPageNew -> share error ->", logdetails.join(" | "), err);
      });
    } else {
      // Fallback: copy to clipboard
      navigator.clipboard.writeText(shareUrl);
      alert(t("Link_copied_tr") || "Link copied to clipboard!");
    }
  };

  /** HH:MM:SS for duration pill and bottom player time (e.g. 01:06:00) */
  const formatPlayerTime = (seconds: number) => {
    if (!seconds || isNaN(seconds)) return "00:00:00";
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    return `${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  // Keep shared <audio> volume in sync with bottom bar
  useEffect(() => {
    const audioEl = getSharedAudio();
    if (!audioEl) return;
    audioEl.volume = isMuted ? 0 : volume;
    audioEl.muted = isMuted;
  }, [volume, isMuted, currentAudio]);

  // Apply loop when repeat toggles
  useEffect(() => {
    const audioEl = getSharedAudio();
    if (!audioEl) return;
    audioEl.loop = repeat;
  }, [repeat, currentAudio]);

  // Update time and duration from audio element
  useEffect(() => {
    const audioElement = getSharedAudio();
    if (!audioElement) return;

    const handleTimeUpdate = () => {
      setCurrentTime(audioElement.currentTime);
      setDuration(audioElement.duration || 0);
    };

    const handleLoadedMetadata = () => {
      setDuration(audioElement.duration || 0);
    };

    // Sync playing flag from element (autoplay / external pause)
    const handlePlay = () => setPlayingAudio(true);
    const handlePause = () => setPlayingAudio(false);

    audioElement.addEventListener("timeupdate", handleTimeUpdate);
    audioElement.addEventListener("loadedmetadata", handleLoadedMetadata);
    audioElement.addEventListener("play", handlePlay);
    audioElement.addEventListener("pause", handlePause);

    // Apply current volume as soon as element exists
    audioElement.volume = isMuted ? 0 : volume;
    audioElement.muted = isMuted;

    return () => {
      audioElement.removeEventListener("timeupdate", handleTimeUpdate);
      audioElement.removeEventListener("loadedmetadata", handleLoadedMetadata);
      audioElement.removeEventListener("play", handlePlay);
      audioElement.removeEventListener("pause", handlePause);
    };
  }, [currentAudio]);

  return (
    <div className="audio-player-page-wrapper">
      {/* SEO Component for Audio Player Page */}
      <AudioSeo
        audio={currentAudio}
        canonicalPath={canonicalPath}
        type={audioType}
      />
      
      {/* Books-style breadcrumb — tucks under header so yellow shows through wavy edge */}
      <div
        className="audio-player-breadcrumb-band"
        style={{
          width: "100%",
          marginTop: "-175px",
          backgroundColor: "#ffedbc",
          height: "230px",
          /* No white border — keeps yellow continuous into content area */
          borderBottom: "none",
          paddingTop: 0,
        }}
      >
        <div className="audio-player-breadcrumb-inner">
          <div className="containers">
            <span className="audio-player-breadcrumb-title">
              {t(`${Type}_breadcrumb_tr`)}
            </span>
            <div className="audio-player-breadcrumb-trail">
              <Link to="/">{t("Home_tr")}</Link>
              <Link to={`/${Type}`}>
                / {t(`${Type}_breadcrumb_tr`)}
              </Link>
              <span>/ {currentAudio?.name || "..."}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="containers">
        {/* Two-column toolbar: Related header (left) | Wave + title + actions (right) */}
        <div className="audio-player-toolbar">
          {/* Left column — aligns with sidebar (col-xl-5 / col-lg-6) */}
          <div className="audio-toolbar-left">
            <button
              type="button"
              title="back"
              aria-label="Back"
              className="audio-toolbar-back"
              onClick={() => {
                const logdetails: string[] = [];
                logdetails.push(`action=back_clicked`);
                logdetails.push(`navigate_to=/${Type}`);
                console.log("AudioPlayerPageNew -> back button ->", logdetails.join(" | "));

                navigate(`/${Type}`);
                setIsMinismise(true);
              }}
            >
              <img alt="Back" src={arrowleft} width="30" />
            </button>
            <span className="audio-toolbar-related-title">{t(relatedListLabelKey)}</span>
          </div>

          {/* Right column — aligns with main card (col-xl-7 / col-lg-6) */}
          <div className="audio-toolbar-right">
            <div className="audio-toolbar-title-row">
              <div
                className="currently-playing-visualizer audio-card-wave audio-toolbar-wave"
                aria-hidden="true"
              >
                <span className={`viz-bar ${playingAudio ? "is-playing" : ""}`} />
                <span className={`viz-bar ${playingAudio ? "is-playing" : ""}`} />
                <span className={`viz-bar ${playingAudio ? "is-playing" : ""}`} />
              </div>
              <h1 className="audio-page-title audio-toolbar-song-title">
                {currentAudio?.name}
              </h1>
            </div>

            {/* Minimize + Close — far right of orange toolbar */}
            <div className="audio-toolbar-actions">
              <button
                type="button"
                aria-label="Minimize"
                title="Minimize"
                className="audio-toolbar-icon-btn"
                onClick={() => {
                  const logdetails: string[] = [];
                  logdetails.push(`action=minimize_clicked`);
                  logdetails.push(`navigate_to=/${Type}`);
                  console.log("AudioPlayerPageNew -> minimize button ->", logdetails.join(" | "));

                  setIsMinismise(true);
                  navigate(`/${Type}`);
                }}
              >
                {/* Crisp white SVG icons on orange toolbar — no white outer circle */}
                <svg className="audio-toolbar-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <circle cx="12" cy="12" r="9.5" fill="none" stroke="currentColor" strokeWidth="2.25" />
                  <path d="M7 12h10" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                </svg>
              </button>
              <button
                type="button"
                aria-label="Close"
                title="Close"
                className="audio-toolbar-icon-btn"
                onClick={() => {
                  const logdetails: string[] = [];
                  logdetails.push(`action=close_clicked`);
                  logdetails.push(`navigate_to=/${Type}`);
                  console.log("AudioPlayerPageNew -> close button ->", logdetails.join(" | "));

                  close();
                  setPlayingAudio(false);
                  navigate(`/${Type}`);
                }}
              >
                <svg className="audio-toolbar-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <circle cx="12" cy="12" r="9.5" fill="none" stroke="currentColor" strokeWidth="2.25" />
                  <path d="M8.2 8.2l7.6 7.6M15.8 8.2l-7.6 7.6" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div
          className="row audio-player-centered-row"
          style={{
            borderBottomColor: "black",
            marginRight: "0px",
          }}
        >
          {/* Sidebar - Left Column */}
          <div
            className="col-xl-5 col-lg-6 audio-player-sidebar-col"
          >
            <div className="songSidebar">
              {/* Related Audio list — header lives in audio-player-toolbar left column */}
              <div className="related-audio-list">
                {relatedAudios.map((a, i) => (
                  <div key={a?.id}>
                    <div
                      id={a?.id}
                      className="audio-item"
                      onClick={() => {
                        const logdetails: string[] = [];
                        const realIndex = audiosList.findIndex((x) => x.id === a.id);
                        logdetails.push(`action=related_audio_clicked`);
                        logdetails.push(`audioId=${a.id}`);
                        logdetails.push(`filtered_index=${i}`);
                        logdetails.push(`real_index=${realIndex}`);
                        logdetails.push(`slug=${a.slug}`);
                        logdetails.push(`name=${a.name}`);
                        console.log("AudioPlayerPageNew -> clicked related audio ->", logdetails.join(" | "));

                        if (realIndex < 0) {
                          logdetails.push("result=skip_not_in_audiosList");
                          console.warn("AudioPlayerPageNew -> related click skipped ->", logdetails.join(" | "));
                          return;
                        }
                        playAudio(a.id, realIndex, a.slug);
                      }}
                    >
                      <img
                        className="related-audio-thumb"
                        src={
                          !(a.lyricsPath || a.lyricsHash)
                            ? WithoutLyrics
                            : WithLyrics
                        }
                        alt=""
                      />

                      <div className="audio-item-content">
                        <p className="audio-title audio-title-normal" title={a.name || undefined}>
                          {a.name}
                        </p>
                        {/* Always render author line so title stays top-aligned when author is missing */}
                        <p className="audio-author">
                          {a.author ? a.author : "\u00A0"}
                        </p>
                      </div>

                      {a.id === nextPlaylistAudioId && (
                        <span className="related-audio-next-pill" aria-label={t("next_tr")}>
                          {t("next_tr")}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* 4. View All — caption matches product type (Audios / Pravachans / Daily Satsang) */}
              <div className="see-all-button">
                <button
                  type="button"
                  aria-label={t(seeAllLabelKey)}
                  onClick={() => {
                    const logdetails: string[] = [];
                    logdetails.push(`action=see_all_clicked`);
                    logdetails.push(`product_type=${audioType}`);
                    logdetails.push(`label_key=${seeAllLabelKey}`);
                    logdetails.push(`navigate_to=/${Type}`);
                    console.log("AudioPlayerPageNew -> see all button ->", logdetails.join(" | "));
                    
                    navigate(`/${Type}`);
                    setIsMinismise(true);
                  }}
                >
                  {t(seeAllLabelKey)}
                </button>
              </div>
            </div>
          </div>

          {/* Main Content - Right Column */}
          <div className="col-xl-7 col-lg-6 no-copy audio-player-main-col">
            {currentAudio && (
              /* Single audio card: title, image, lyrics, and player controls */
              <div className="audio-player-header">
                <div className="audio-card-top">
                  {/* Title + wave moved to audio-player-toolbar right column */}
                  <div className="audio-card-info">
                    <div className="audio-meta-pills">
                      {currentAudio.author && (
                        <span className="audio-meta-pill" title={currentAudio.author}>
                          <svg className="audio-meta-pill-icon" viewBox="0 0 24 24" aria-hidden="true">
                            <circle cx="12" cy="8" r="3.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
                            <path d="M5 19c0-3.5 3.1-6 7-6s7 2.5 7 6" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                          </svg>
                          <span className="audio-meta-pill-text">{currentAudio.author}</span>
                        </span>
                      )}
                      <span className="audio-meta-pill">
                        <svg className="audio-meta-pill-icon" viewBox="0 0 24 24" aria-hidden="true">
                          <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="1.6" />
                          <path d="M12 8v4.5l3 1.5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span className="audio-meta-pill-text">
                          {/* HH:MM:SS — same format as bottom player (e.g. 01:06:00) */}
                          {formatPlayerTime(duration || currentAudio.audioLength)}
                        </span>
                      </span>
                    </div>
                  </div>

                  <div className="action-buttons">
                    <button
                      onClick={handleAddToFavorite}
                      className={`btn-favorite ${isFavorite ? 'active' : ''}`}
                      aria-label="Add to Favorites"
                    >
                      <span className="heart-icon">{isFavorite ? '♥' : '♡'}</span>
                      {t("add_to_favorite_tr")}
                    </button>
                    <button
                      onClick={handleShare}
                      className="btn-share"
                      aria-label="Share"
                    >
                      <svg className="share-icon-svg" viewBox="0 0 24 24" aria-hidden="true">
                        <circle cx="18" cy="5" r="2.5" fill="currentColor" />
                        <circle cx="6" cy="12" r="2.5" fill="currentColor" />
                        <circle cx="18" cy="19" r="2.5" fill="currentColor" />
                        <path d="M8.2 13.2l7.6 4.4M15.8 6.4l-7.6 4.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
                      </svg>
                      {t("Share_tr")}
                    </button>
                  </div>
                </div>

                {/* Lyrics full width of audio card */}
                <div className="row audio-content-row">
                  <div className="col-12 audio-lyrics-section">
                    {/* Ornamental frame from 3 images: TL corner, BL corner, left side bar */}
                    <div className="lyrics-container">
                      <div className="lyrics-frame" aria-hidden="true">
                        {/* Top-left corner */}
                        <img
                          src={lyricsCornerTopLeft}
                          alt=""
                          className="lyrics-frame-corner lyrics-frame-corner--tl"
                        />
                        {/* Top-right = top-left flipped horizontally */}
                        <img
                          src={lyricsCornerTopLeft}
                          alt=""
                          className="lyrics-frame-corner lyrics-frame-corner--tr"
                        />
                        {/* Bottom-left corner */}
                        <img
                          src={lyricsCornerBottomLeft}
                          alt=""
                          className="lyrics-frame-corner lyrics-frame-corner--bl"
                        />
                        {/* Bottom-right = bottom-left flipped horizontally */}
                        <img
                          src={lyricsCornerBottomLeft}
                          alt=""
                          className="lyrics-frame-corner lyrics-frame-corner--br"
                        />
                        {/* Left vertical side bar */}
                        <img
                          src={lyricsSideLeft}
                          alt=""
                          className="lyrics-frame-side lyrics-frame-side--left"
                        />
                        {/* Right vertical side bar = left flipped horizontally */}
                        <img
                          src={lyricsSideLeft}
                          alt=""
                          className="lyrics-frame-side lyrics-frame-side--right"
                        />
                        {/* Top / bottom edges reuse left side bar image stretched horizontally */}
                        <img
                          src={lyricsSideLeft}
                          alt=""
                          className="lyrics-frame-side lyrics-frame-side--top"
                        />
                        <img
                          src={lyricsSideLeft}
                          alt=""
                          className="lyrics-frame-side lyrics-frame-side--bottom"
                        />
                      </div>
                      <div className="lyrics-frame-content">
                        <AudioLyrics />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Full-width player controls — below left + right cards */}
        {currentAudio && (
          <div className="audio-page-bottom-player" role="region" aria-label="Audio player controls">
            <div className="bottom-player-track">
              {/* Fallback thumb: with-lyrics vs without-lyrics icon from audio meta (not always WithLyrics) */}
              <img
                className="bottom-player-thumb"
                src={
                  currentAudio.imagePath ||
                  (!!(currentAudio.lyricsPath || currentAudio.lyricsHash)
                    ? WithLyrics
                    : WithoutLyrics)
                }
                alt=""
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  const hasLyrics = !!(currentAudio.lyricsPath || currentAudio.lyricsHash);
                  target.src = hasLyrics ? WithLyrics : WithoutLyrics;
                }}
              />
              <div className="bottom-player-meta">
                <div className="bottom-player-title" title={currentAudio.name}>
                  {currentAudio.name}
                </div>
                {currentAudio.author && (
                  <div className="bottom-player-author" title={currentAudio.author}>
                    {currentAudio.author}
                  </div>
                )}
              </div>
            </div>

            <div className="bottom-player-transport">
              <button
                type="button"
                className={`bottom-player-btn bottom-player-fav ${isLiked || isFavorite ? "active" : ""}`}
                aria-label="Add to Favorites"
                title="Favorite"
                onClick={handleAddToFavorite}
              >
                <img src={isLiked || isFavorite ? Favadd : Favicon} alt="" width="28" />
              </button>
              <button
                type="button"
                onClick={toggleShuffle}
                className={`bottom-player-btn ${shuffle ? "active" : ""}`}
                aria-label="Shuffle"
                title="Shuffle"
              >
                <img src={imgshuffle} alt="" width="28" />
              </button>
              <button
                type="button"
                onClick={playPrevious}
                className="bottom-player-btn"
                aria-label="Previous"
                title="Previous"
              >
                <img src={imgback} alt="" width="28" />
              </button>
              <button
                type="button"
                onClick={togglePlayPause}
                className="bottom-player-play"
                aria-label={playingAudio ? "Pause" : "Play"}
                title={playingAudio ? "Pause" : "Play"}
              >
                <img
                  src={playingAudio ? imgpause : imgplay}
                  alt=""
                  width="44"
                />
              </button>
              <button
                type="button"
                onClick={playNext}
                className="bottom-player-btn"
                aria-label="Next"
                title="Next"
              >
                <img src={imgforward} alt="" width="28" />
              </button>
              <button
                type="button"
                onClick={toggleRepeat}
                className={`bottom-player-btn ${repeat ? "active" : ""}`}
                aria-label="Repeat"
                title="Repeat"
              >
                <img
                  src={repeat ? imgrepeatOn : imgrepeatOff}
                  alt=""
                  width="28"
                />
              </button>
              <button
                type="button"
                onClick={changePlaybackSpeed}
                className="bottom-player-speed"
                aria-label={`Playback speed ${playbackSpeed}x`}
                title="Change speed"
              >
                {playbackSpeed}x
              </button>
            </div>

            <div className="bottom-player-progress">
              <span className="bottom-player-time">
                {formatPlayerTime(currentTime)} / {formatPlayerTime(duration || currentAudio.audioLength)}
              </span>
              <input
                type="range"
                className="bottom-player-seek"
                value={currentTime}
                max={duration || 100}
                onChange={handleSeek}
                style={{
                  '--progress': `${(currentTime / (duration || 1)) * 100}%`
                } as React.CSSProperties}
                aria-label="Audio progress"
              />
            </div>

            <div className="bottom-player-volume">
              <button
                type="button"
                className="bottom-player-btn"
                onClick={toggleMute}
                aria-label={isMuted ? "Unmute" : "Mute"}
              >
                <img src={isMuted || volume === 0 ? muteIcon : volumeIcon} alt="" width="24" />
              </button>
              <input
                type="range"
                className="bottom-player-volume-slider"
                min={0}
                max={1}
                step={0.01}
                value={volume}
                onChange={handleVolumeChange}
                aria-label="Volume"
              />
            </div>
          </div>
        )}
      </div>

      <LogInModel
        opens={logIn}
        onCloses={() => setLogIn(false)}
        onLoginStateChange={(loggedIn: boolean) => {
          if (loggedIn) setLogIn(false);
        }}
      />
    </div>
  );
};

export default AudioPlayerPageNew;
